import { render, staticRenderFns } from "./serviceObject.vue?vue&type=template&id=133dbd48&scoped=true&"
import script from "./serviceObject.vue?vue&type=script&lang=js&"
export * from "./serviceObject.vue?vue&type=script&lang=js&"
import style0 from "./serviceObject.vue?vue&type=style&index=0&id=133dbd48&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133dbd48",
  null
  
)

export default component.exports